import {
  Library,
  Tags,
  Languages as LangIcon,
  TrendingUp,
  FileText,
  Sparkles,
} from "lucide-react";

const features = [
  {
    icon: Library,
    title: "Your library, your rules",
    body: "Drop in anything. Novels, news clippings, song lyrics, subtitles, a friend's blog. No curated catalogue to outgrow.",
    span: "md:col-span-2",
    rowSpan: 2,
    image: "/demo-screenshot-library.png",
  },
  {
    icon: Tags,
    title: "Words travel between texts",
    body: "Mark a word as known once. It stays known in every other text in that language, forever.",
  },
  {
    icon: TrendingUp,
    title: "Priority algorithm",
    body: "We surface the three highest-frequency new words on every page. Crack those and the rest falls.",
  },
  {
    icon: LangIcon,
    title: "Track many languages",
    body: "One dashboard. Polish, Spanish, German, whatever — each gets its own stats, library, dictionary, vocabulary and progress.",
  },
  {
    icon: FileText,
    title: "Per-page familiarity",
    body: "See exactly how much of any page you can already read before you commit.",
  },
  {
    icon: Sparkles,
    title: "Word-state legend",
    body: "Known · priority · new · ignored · rare. Subtle colour gives you the whole page at a glance.",
  },
];

export const Features = () => {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative py-24 sm:py-28 border-t border-[var(--vb-border)]"
    >
      <div className="container-x">
        <div className="mb-12 max-w-3xl reveal">
          <div className="mono-label mb-3">[ 04 · What's in it ]</div>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.02]">
            Quiet tools.{" "}
            <span className="text-[var(--vb-muted)] italic font-light">
              Loud results.
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 md:auto-rows-fr gap-5">
          {features.map((f, i) => (
            <div
              key={i}
              data-testid={`feature-${i}`}
              className={`card-soft p-7 flex flex-col reveal ${f.span ?? ""}`}
              style={{
                transitionDelay: `${i * 60}ms`,
                ...(f.rowSpan ? { gridRow: `span ${f.rowSpan}` } : {}),
              }}
            >
              <div className="flex items-start justify-between mb-8">
                <div className="w-10 h-10 rounded-lg bg-[var(--vb-primary-soft)] border border-[rgba(95,168,255,0.3)] flex items-center justify-center">
                  <f.icon size={16} className="text-[var(--vb-primary)]" />
                </div>
                <span className="mono-label">
                  / {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-display font-bold text-xl tracking-tight mb-2">
                {f.title}
              </h3>
              <p className="text-[var(--vb-muted)] text-[15px] leading-relaxed">
                {f.body}
              </p>
              {f.image && (
                <div className="mt-auto -mx-7 -mb-7 mt-5">
                  <img
                    src={f.image}
                    alt={f.title}
                    className="w-full rounded-b-lg"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
